import styled from 'styled-components'

import { ShortcutCheatSheetFilter } from '@root/features/shortcut/ui/shortcut-cheat-sheet-filter'

ShortcutCheatSheetFilter!
export const SettingsShortcuts = () => {
  return (
    <Root>
      <ShortcutCheatSheetFilter />
    </Root>
  )
}

const Root = styled.div`
  padding: 12px;
`
